import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './AdminLayout.css';

function AdminLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { path: '/admin/dashboard', label: 'Dashboard' },
    { path: '/admin/products', label: 'Manage Products' },
    { path: '/admin/image-cleanup', label: 'Image Cleanup' },
    { path: '/admin/orders', label: 'View Orders' },
    { path: '/admin/users', label: 'Manage Users' },
    { path: '/admin/transactions', label: 'Transactions' },
    { path: '/admin/pages', label: 'Content (CMS)' },
    { path: '/admin/shipping-settings', label: 'Shipping Settings' },
    { path: '/admin/settings', label: 'Settings' },
    { path: '/admin/logs', label: 'View Logs' }
  ];

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('user');
    // Dispatch custom event to notify Header component
    window.dispatchEvent(new Event('logout'));
    navigate('/');
  };

  return (
    <div className="admin-layout">
      <div className="admin-header-bar">
        <div className="admin-branding">
          <h2>WTF Wear Admin</h2>
        </div>
        <div className="admin-actions">
          <button onClick={() => navigate('/')} className="btn-back">
            ← Back to Store
          </button>
          <button onClick={handleLogout} className="btn-logout">
            Logout
          </button>
        </div>
      </div>

      <div className="admin-tabs">
        {tabs.map(tab => (
          <button
            key={tab.path}
            className={`admin-tab ${isActive(tab.path) ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="admin-content">
        {children}
      </div>
    </div>
  );
}

export default AdminLayout;
